import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { AuthDetailTable } from "@/pages/authorization-management/components/auth-detail-table";
import {
  AuthViewPageWrapper,
  Label,
  Section,
  AccountCardWrapper,
  ExpireDate,
  TableSection,
  OperationSection,
} from "@/pages/authorization-management/views/auth-view-page/atom";
import { useAuthManageStore } from "@/pages/authorization-management/store/auth-manage-store";
import { getPlatformTranslation } from "@/pages/authorization-management/helper/getPlatformTranslation";
import { AuthStatus } from "@/pages/authorization-management/constants/authStatus";
import { Button } from "@renderbus/ui";
import { Modal } from "@/components/renderbus-modal";
import { useAuthViewStore } from "@/pages/authorization-management/views/auth-view-page/hooks/auth-view-store";
import { useGlobalStore } from "@/store/GlobalStore";

export function AuthViewPage() {
  const { t } = useTranslation("center");
  const { authRecord, authStatus, setOpenEditAuthDrawer, closeAuth } =
    useAuthManageStore();
  const { openCloseAuthModal, setOpenCloseAuthModal } = useAuthViewStore();
  const { userInfo } = useGlobalStore();
  const plaformTexts = getPlatformTranslation(authRecord?.platforms);
  const leftDays = authRecord
    ? +new Date(authRecord.endDate - +new Date()) / 24 / 60 / 60 / 1000
    : 0;
  return (
    <AuthViewPageWrapper>
      <Section className="account">
        <Label>{t("user_auth_account")}</Label>
        <AccountCardWrapper>
          <div className="gap-item-wrapper">
            {authRecord?.authAccounts.map((item, index) => (
              <div key={item.userId}>
                <span>
                  {item.userName}
                  {item.userId === userInfo?.userId &&
                    `（${t("user_current_account")}）`}
                </span>
                {index !== authRecord?.authAccounts.length - 1 && (
                  <div className="gap">|</div>
                )}
              </div>
            ))}
          </div>
        </AccountCardWrapper>
      </Section>
      <Section className="expire">
        <Label>{t("user_auth_key_expire")}</Label>
        <ExpireDate>
          <span>{`${dayjs(authRecord?.startDate).format(
            "YYYY.MM.DD HH:mm:ss"
          )} - ${dayjs(authRecord?.endDate).format(
            "YYYY.MM.DD HH:mm:ss"
          )}`}</span>
          {authRecord &&
            authStatus === AuthStatus.Effective &&
            leftDays > 0 && (
              <span className="left">{`${t("user_auth_left", {
                0: leftDays ? leftDays.toFixed(0) : "",
              })}`}</span>
            )}
          <span
            className="status-text"
            style={{
              color:
                authRecord &&
                authStatus === AuthStatus.Effective &&
                leftDays > 0
                  ? "#13CB75"
                  : "#E25C59",
            }}
          >
            {authRecord && authStatus === AuthStatus.Effective && leftDays > 0
              ? t("user_auth_status_Activity")
              : t("user_auth_status_Expired")}
          </span>
        </ExpireDate>
      </Section>
      <Section className="platform">
        <Label>{t("user_auth_platform")}</Label>
        <div className="gap-item-wrapper">
          {plaformTexts.map((item, index) => (
            <div key={item}>
              <span>{item}</span>
              {index !== plaformTexts.length - 1 && (
                <div className="gap">|</div>
              )}
            </div>
          ))}
        </div>
      </Section>
      <TableSection>
        <Label>{t("auth_manage_page")}</Label>
        <AuthDetailTable />
      </TableSection>
      <OperationSection>
        <Button className="close" onClick={() => setOpenCloseAuthModal(true)}>
          {t("user_close_auth")}
        </Button>
        <Button
          className="edit"
          onClick={() => {
            setOpenEditAuthDrawer(true);
          }}
        >
          {t("user_edit_auth")}
        </Button>
      </OperationSection>
      <Modal
        open={openCloseAuthModal}
        title={t("user_close_auth_declare")}
        onCancel={() => setOpenCloseAuthModal(false)}
        onOk={closeAuth}
      >
        {t("user_auth_close_warning")}
      </Modal>
    </AuthViewPageWrapper>
  );
}
